import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { inr0 } from "@/lib/format";

export const TargetBar = ({ done, target, money, compact, testid }) => {
  const fmt = (n) => (money ? inr0(n) : Math.round(n));
  if (!target) return <div className={`text-xs text-muted-foreground ${compact ? "mt-2" : ""}`} data-testid={testid}>{compact ? "No target set" : `${fmt(done)} · no target`}</div>;
  const pct = Math.round((100 * done) / target);
  const tone = pct >= 100 ? "bg-emerald-600" : pct >= 60 ? "bg-[#D96B43]" : "bg-rose-500";
  return (
    <div className={compact ? "mt-2" : ""} data-testid={testid}>
      <div className="h-2 rounded-full bg-[#F1EDE3]"><div className={`h-2 rounded-full transition-[width] duration-700 ${tone}`} style={{ width: `${Math.min(pct, 100)}%` }} /></div>
      <div className="mt-1 flex justify-between text-[11px] text-muted-foreground"><span>{compact ? "" : `${fmt(done)} of `}{fmt(target)}{compact ? " target" : ""}</span><span className={`font-semibold ${pct >= 100 ? "text-emerald-700" : ""}`}>{pct}%</span></div>
    </div>
  );
};

export const TargetEditor = ({ rep, month, onSaved }) => {
  const [conv, setConv] = useState(rep.target_converted || "");
  const [val, setVal] = useState(rep.target_value || "");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setConv(rep.target_converted || ""); setVal(rep.target_value || ""); }, [rep.target_converted, rep.target_value, month]);
  const changed = String(conv || 0) !== String(rep.target_converted || 0) || String(val || 0) !== String(rep.target_value || 0);
  const save = async () => {
    setBusy(true);
    try { await api.put(`/sales/targets/${rep.id}`, { month, converted: +conv || 0, value: +val || 0 }); toast.success(`Target saved for ${rep.name}`); onSaved(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-1.5">
      <Input type="number" min="0" value={conv} onChange={(e) => setConv(e.target.value)} placeholder="Members" className="h-8 w-24 text-xs" data-testid={`target-input-converted-${rep.id}`} />
      <Input type="number" min="0" value={val} onChange={(e) => setVal(e.target.value)} placeholder="₹ value" className="h-8 w-28 text-xs" data-testid={`target-input-value-${rep.id}`} />
      <Button size="sm" variant="outline" disabled={!changed || busy} onClick={save} className="h-8 rounded-full" data-testid={`target-save-${rep.id}`}>{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Save"}</Button>
    </div>
  );
};
